import styled from "styled-components";

export const LegacyCellTooltipAnchor = styled.span`
    display: block;
    width: 100%;
`;
